/* Paintly Diamond Painting variant picker.
   Proxies a custom UI to the native variant-selects engine:
   Diamond Shape (radios), Size (select), Frame (select).
   Variant options order: [Diamond Shape, Size, Frame]. */
(function () {
  var SQ = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="4" y="4" width="16" height="16" rx="2"/></svg>';
  var POR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="6" y="3" width="12" height="18" rx="2"/></svg>';
  var LAN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="3" y="6" width="18" height="12" rx="2"/></svg>';

  function fire(el) { if (el) el.dispatchEvent(new Event('change', { bubbles: true })); }

  function init(vs) {
    var ui = vs.querySelector('.pbnvp');
    if (!ui || ui.dataset.wired) return;
    ui.dataset.wired = '1';

    var shapeInputs = [].slice.call(vs.querySelectorAll('input[name="Diamond Shape"], input[name="Shape"], input[name="Diamonds"]'));
    /* Where the material rides on the same option, its values are two words: "Square Resin". The
       page asks the two questions separately, so the two answers are recombined here in the order
       the option value is written. Everything downstream, sold-out marking included, still works on
       the one combined value. */
    var splitMat = shapeInputs.some(function (r) { return r.value.indexOf(' ') > 0; });
    function partsOf(v) { var b = (v || '').split(' '); return { shape: b[0] || '', mat: b[1] || '' }; }
    function joinParts(shape, mat) { return mat ? shape + ' ' + mat : shape; }
    var sizeSel = vs.querySelector('select[name="options[Size]"]');
    var frameSel = vs.querySelector('select[name="options[Frame]"]');

    /* "Max Colors (up to 150)" rides on the Frame option as a value of its own: those kits only come
       unframed, and a product has no fourth option slot to give it. The page asks it as a
       separate "Colors" question, Standard or Max. Everything below that mentions HC is
       inert on a product without that value, so every other product behaves exactly as before. */
    var HC = 'Max Colors (up to 150)';
    var hasHC = !!(frameSel && [].some.call(frameSel.options, function (o) { return o.value === HC; }));
    var lastStdFrame = (frameSel && frameSel.value !== HC) ? frameSel.value : 'Without Frame';
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    /* The "What's the difference?" pop-up. It is moved to <body> so no sticky header or transformed
       parent can cover or clip it; a copy left there by an earlier render of this picker goes first. */
    var mx = hasHC ? ui.querySelector('.pbnvp-mx') : null, mxBack = null, mxT = null;
    if (mx) {
      [].forEach.call(document.querySelectorAll('body > .pbnvp-mx'), function (o) { o.parentNode.removeChild(o); });
      document.body.appendChild(mx);
      mx.addEventListener('click', function (e) {
        if (e.target.closest('[data-mx-close]')) { closeMx(); return; }
        var pk = e.target.closest('[data-mx-pick]');
        if (pk) {
          var want = pk.getAttribute('data-mx-pick');
          closeMx();
          /* let the sheet start to leave first, then flip the switch in view */
          setTimeout(function () { var b = ui.querySelector('[data-tier="' + want + '"]'); if (b) b.click(); }, reduceMotion ? 0 : 260);
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mx.classList.contains('is-open')) closeMx(); });
    }
    function openMx(from) {
      if (!mx) return;
      mxBack = from || null;
      clearTimeout(mxT);
      mx.hidden = false;
      void mx.offsetWidth;
      mx.classList.add('is-open');
      document.documentElement.classList.add('pbnvp-mx-lock');
      var sh = mx.querySelector('.pbnvp-mx-sheet'); if (sh) sh.scrollTop = 0;
      var x = mx.querySelector('.pbnvp-mx-x'); if (x) { try { x.focus({ preventScroll: true }); } catch (err) { x.focus(); } }
    }
    function closeMx() {
      if (!mx || !mx.classList.contains('is-open')) return;
      mx.classList.remove('is-open');
      document.documentElement.classList.remove('pbnvp-mx-lock');
      mxT = setTimeout(function () { mx.hidden = true; }, reduceMotion ? 0 : 450);
      if (mxBack && mxBack.focus) { try { mxBack.focus({ preventScroll: true }); } catch (err) { mxBack.focus(); } }
    }
    /* the Max Colors bar further down the page opens the same pop-up */
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-mx-open]');
      if (o && !ui.contains(o) && mx && document.body.contains(mx)) { e.preventDefault(); openMx(o); }
    });

    function stdFrames() {
      return frameSel ? [].map.call(frameSel.options, function (o) { return o.value; }).filter(function (v) { return v !== HC; }) : [];
    }

    var variants = [];
    try { variants = JSON.parse(vs.querySelector('script[type="application/json"]').textContent) || []; } catch (e) {}


    var variantLoad = vs.__pkVariantLoad = { state: variants.length >= 250 ? 'loading' : 'ready', retry: null };
    function variantState(state) {
      variantLoad.state = state;
      vs.dispatchEvent(new CustomEvent('paintly:variants-state', { detail: { state: state } }));
    }

    /* Liquid prints at most 250 variants, and four products have more than that. The picker decides
       what is sold out from this list, so a variant missing from it reads as one that does not
       exist and its card greys for no reason. The theme already carries a section that pages
       through the rest, which is what the paint by numbers form uses; the product's own .js
       endpoint is capped at 250 as well, so it is no use here.

       Do not ask the page how many variants it has: data-variant-count is rendered from
       product.variants.size, which Liquid caps at 250 exactly like the list, so the page reports
       250 on a 272 variant product and any "is the list short" test compares 250 with 250 and
       never fires. What can be trusted is the cap itself. A printed list of exactly 250 is the
       only length that can mean there may be more, so that is the trigger. A product that really
       has 250 and no more costs one fetch that finds nothing. */
    /* The theme's own variant-selects (Shrine main.js) finds the variant for the form from the same
       capped list: it reads the JSON once into vs.variantData. Give it the extra variants in the shape
       Liquid prints (copied from the first one), both in that cache and in the script it reads from, or
       a combination past 250 resolves to nothing and the form keeps an earlier variant. */
    function feedBase(list) {
      var tpl = variants[0];
      if (!tpl || !list.length) return;
      var full = list.map(function (v) {
        var o = {};
        for (var k in tpl) if (Object.prototype.hasOwnProperty.call(tpl, k)) o[k] = tpl[k];
        o.id = v.id; o.title = v.title; o.public_title = v.title; o.options = v.options;
        o.option1 = v.options[0] || null; o.option2 = v.options[1] || null; o.option3 = v.options[2] || null;
        o.available = v.available; o.price = v.price_cents;
        o.compare_at_price = v.compare_at_price_cents == null ? null : v.compare_at_price_cents;
        o.name = String(tpl.name || '').split(' - ')[0] + ' - ' + v.title;
        o.sku = null; o.barcode = null; o.featured_image = null; o.featured_media = null;
        return o;
      });
      var add = function (arr) {
        var have = {}; arr.forEach(function (x) { if (x) have[x.id] = 1; });
        full.forEach(function (f) { if (!have[f.id]) arr.push(f); });
      };
      if (Array.isArray(vs.variantData)) add(vs.variantData);
      var sc = vs.querySelector('script[type="application/json"]');
      if (sc) { try { var arr = JSON.parse(sc.textContent) || []; add(arr); sc.textContent = JSON.stringify(arr); } catch (e) {} }
    }

    /* one page of variants past 250, tried up to 3 times: a dropped connection or a check page from the
       store's bot protection must not leave the page with only the first 250 (1 Oct 2026) */
    function getPage(url, tries) {
      tries = tries || 0;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (t) { if (!/id="paintly-variants-page"/.test(t)) throw new Error('no variant data'); return t; })
        .catch(function (err) {
          if (tries >= 2) throw err;
          return new Promise(function (res) { setTimeout(res, 800 * (tries + 1)); }).then(function () { return getPage(url, tries + 1); });
        });
    }
    var vsUrl = vs.getAttribute('data-url');
    if (variants.length >= 250 && vsUrl) {
      var page = 2;
      var pull = function () {
        getPage(vsUrl + '?section_id=paintly-variants-json&page=' + page)
          .then(function (html) {
            var m = html.match(/id="paintly-variants-page"[^>]*>([\s\S]*?)<\/script>/);
            if (!m) throw new Error('no variant data');
            var d = JSON.parse(m[1]);
            if (!Array.isArray(d.variants) || +d.page !== page || !(+d.pages >= page) || +d.pages > 20) throw new Error('invalid variant page');
            var before = variants.length;
            (d.variants || []).forEach(function (v) {
              if (!variants.some(function (x) { return String(x.id) === String(v.id); })) variants.push({ id: v.id, options: v.options, available: v.available, price: v.price_cents });
            });
            feedBase(d.variants || []);
            if (variants.length !== before) sync();
            /* the feed reports how many pages it has; the old stop compared against the same
               capped number and would have given up after page two on a bigger product */
            if (page < d.pages) { page += 1; pull(); }
            else { syncAll(); variantState('ready'); }
          })
          .catch(function () { if (vs.isConnected) variantState('error'); });
      };
      variantLoad.retry = function () {
        if (variantLoad.state !== 'error') return;
        page = 2; variantState('loading'); pull();
      };
      pull();
    }

    function exists(shape, size, frame) {
      return variants.some(function (v) {
        if (!v || !v.options || v.available === false) return false;
        if (shape != null && v.options[0] !== shape) return false;
        if (size != null && v.options[1] !== size) return false;
        if (frame != null && v.options[2] !== frame) return false;
        return true;
      });
    }
    function curShape() { var r = shapeInputs.filter(function (x) { return x.checked; })[0]; return r ? r.value : null; }

    var dd = ui.querySelector('.pbnvp-dd');
    var ddbtn = ui.querySelector('.pbnvp-ddbtn');
    if (ddbtn && dd) {
      ddbtn.addEventListener('click', function (e) {
        e.stopPropagation();
        dd.classList.toggle('open');
        if (dd.classList.contains('open')) openPanel();
      });
      document.addEventListener('click', function (e) { if (!dd.contains(e.target)) dd.classList.remove('open'); });
    }
    /* Mirrors the PBN picker. Diamond Painting runs the same 15x price spread over
       its size list - $16 at 15x20cm to $240 at the top - through the same 300px
       keyhole, so it gets the same three fixes: a price on every row, a panel sized
       to the room that exists and flipped above the button when that is where the
       room is, and an open that lands on the current selection. Simpler here than on
       the PBN side because Diamond Painting has no auto-switch: a row either has a
       variant for the current shape and frame or it is greyed, so an unavailable row
       shows no price rather than quoting one it cannot honour. */
    function openPanel(){
      var p = ui.querySelector('.pbnvp-ddpanel');
      if(!p || !ddbtn) return;
      var r = ddbtn.getBoundingClientRect();
      var below = window.innerHeight - r.bottom - 18, above = r.top - 18;
      var up = above > below && below < 520;
      dd.classList.toggle('up', up);
      p.style.maxHeight = Math.round(Math.max(260, Math.min(520, up ? above : below))) + 'px';
      var sel = p.querySelector('.pbnvp-ddrow[aria-pressed="true"]');
      p.scrollTop = sel ? Math.max(0, sel.offsetTop - (p.clientHeight - sel.offsetHeight) / 2) : 0;
    }
    function moneyFmt(c){
      if(typeof c!=='number') return '';
      var cu='USD';
      try{ cu=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'USD'; }catch(e){}
      try{ return new Intl.NumberFormat(undefined,{style:'currency',currency:cu}).format(c/100); }
      catch(e){ return '$'+(c/100).toFixed(2); }
    }
    function priceFor(shape, size, frame){
      var out=null;
      variants.forEach(function(v){
        if(out!=null||!v||!v.options||v.available===false) return;
        if(v.options[0]===shape && v.options[1]===size && v.options[2]===frame && typeof v.price==='number') out=v.price;
      });
      return out;
    }
    function parseCm(str){ var m=String(str||'').match(/(\d+)\s*x\s*(\d+)/i); return m?{w:+m[1],h:+m[2]}:null; }
    function orientOf(str){ var d=parseCm(str); if(!d) return null; return d.w===d.h?'Square':(d.w>d.h?'Landscape':'Portrait'); }
    function sizeValues(){ return [].map.call(ui.querySelectorAll('[data-size]'), function(r){ return r.getAttribute('data-size'); }); }
    function areaOfSize(v){ var d=parseCm(v); return d ? d.w*d.h : 0; }
    /* the candidate closest to where the customer is now: same shape first, then the nearest sides,
       then the nearest area, then the bigger one */
    function nearestSize(cands, cur){
      var a=areaOfSize(cur), best=null, bd=Infinity;
      var o = orientOf(cur), same = o ? cands.filter(function (c) { return orientOf(c) === o; }) : [];
      if (same.length) cands = same;
      var dc = parseCm(cur), ba = Infinity;
      cands.forEach(function(c){
        var q = parseCm(c), da = Math.abs(areaOfSize(c)-a);
        var d = (dc && q) ? Math.abs(q.w-dc.w) + Math.abs(q.h-dc.h) : da;
        if (d<bd || (d===bd && (da<ba || (da===ba && areaOfSize(c)>areaOfSize(best))))) { bd=d; ba=da; best=c; }
      });
      return best;
    }
    /* a standard frame that exists for this drill and size, the one they last chose first */
    function stdFrameFor(shape, size){
      if (exists(shape, size, lastStdFrame)) return lastStdFrame;
      return stdFrames().filter(function(f){ return exists(shape, size, f); })[0] || null;
    }
    /* ---- Max colors notes ------------------------------------------------
       Max colors only comes in the big sizes (80x100cm and up, or 100x80cm wide, never square) and
       Standard stops at 80x100cm, unframed there. So one tap can move another choice. When it does,
       the bar the paint by numbers picker uses (assets/paintly-optswitch.js) says what moved, why and
       what it costs, with Undo. A quiet line under the switch says where Max starts before they tap.
       Wording rules: say each fact once (the line, the bar title, the bar reason and the frame note
       never repeat each other); "Max color kits", plural, like the frame note; no bar when no size
       was chosen yet. */
    var viaShape = null;
    function snapState() { return { shape: curShape(), size: sizeSel ? sizeSel.value : null, frame: frameSel ? frameSel.value : null, pending: pending, lastStd: lastStdFrame }; }
    function cmOnly(v) { return String(v || '').replace(/\s*\(.*$/, ''); }
    /* the smallest Max size in this orientation */
    function maxFrom(shape, ori) {
      var c = sizeValues().filter(function (v) { return orientOf(v) === ori && exists(shape, v, HC); })
        .sort(function (a, b) { return areaOfSize(a) - areaOfSize(b); });
      return c[0] || null;
    }
    /* the biggest Standard size in this orientation */
    function stdTop(shape, ori) {
      var c = sizeValues().filter(function (v) { return orientOf(v) === ori && !!stdFrameFor(shape, v); })
        .sort(function (a, b) { return areaOfSize(a) - areaOfSize(b); });
      return c[c.length - 1] || null;
    }
    /* Max comes wide as well as tall on the custom photo product; regular designs are portrait only */
    function maxWide(shape) { return sizeValues().some(function (v) { return orientOf(v) === 'Landscape' && exists(shape, v, HC); }); }
    function lc(s) { return s.charAt(0).toLowerCase() + s.slice(1); }
    function maxNote(kind, from, anchor) {
      var OS = window.PaintlyOptSwitch;
      if (!OS || !hasHC || !anchor) return;
      var to = snapState();
      var fHC = from.frame === HC, tHC = to.frame === HC;
      /* what the customer sees as the frame: Max shows "Without Frame" */
      var fFrame = fHC ? 'Without Frame' : from.frame, tFrame = tHC ? 'Without Frame' : to.frame;
      var sizeMoved = from.size !== to.size, tierMoved = fHC !== tHC, frameMoved = fFrame !== tFrame;
      var parts = [], reason = '';
      if (kind === 'tier') {
        if (!sizeMoved || from.pending) return;   /* nothing of theirs was overridden */
        var turned = orientOf(from.size) !== orientOf(to.size);
        if (turned && hasShapes) parts.push('Shape is now ' + (orientOf(to.size) === 'Landscape' ? 'Wide' : 'Tall'));
        parts.push('Size is now ' + to.size);
        if (frameMoved) parts.push('Frame is now ' + tFrame);
        /* each reason is only said when the product's own variants make it true; otherwise the plain fallback */
        var atMin = to.size === maxFrom(to.shape, orientOf(to.size));
        if (!tHC) reason = to.size === stdTop(to.shape, orientOf(to.size)) ? 'Standard kits go up to this size.' : cmOnly(from.size) + ' comes in Max colors only.';
        else if (turned) reason = maxWide(to.shape) ? 'Max color kits come in tall and wide sizes only.' : (atMin ? 'Max color kits are portrait only and start at this size.' : 'Max color kits are portrait only.');
        else reason = atMin ? 'Max color kits start at this size.' : cmOnly(from.size) + ' comes in Standard only.';   /* the frame note under Frame already says why the frame went */
      } else {
        if (!tierMoved && !frameMoved) return;
        if (tierMoved) parts.push('Colors switched to ' + (tHC ? 'Max' : 'Standard'));
        if (frameMoved) parts.push('Frame is now ' + tFrame);
        var what = viaShape === 'Square' ? 'Square sizes come' : cmOnly(to.size) + ' comes';
        if (tierMoved && tHC) reason = what + ' in Max colors only.';
        else if (tierMoved) reason = what + ' in Standard only.';
        else reason = cmOnly(to.size) + ' is only sold without a frame.';   /* same words as paint by numbers */
      }
      var title = parts[0];
      for (var i = 1; i < parts.length; i++) title += (i === parts.length - 1 ? ' and ' : ', ') + lc(parts[i]);
      title += '.';
      var priceTxt = '';
      if (!from.pending) {
        var pf = priceFor(from.shape, from.size, from.frame), pt = priceFor(to.shape, to.size, to.frame);
        if (pf != null && pt != null && pf !== pt) priceTxt = 'Price goes from ' + moneyFmt(pf) + ' to ' + moneyFmt(pt) + '.';
      }
      OS.show({
        anchor: anchor, scope: ui, title: title, reason: reason, price: priceTxt,
        onUndo: from.pending ? null : function () {
          lastStdFrame = from.lastStd;
          if (frameSel) frameSel.value = from.frame;
          if (sizeSel) { sizeSel.value = from.size; fire(sizeSel); } else fire(frameSel);
        }
      });
    }
    /* the quiet line under the switch, while Standard is on and the size (or no size yet) is too small for Max */
    function hcFromLine(onHC, cs, cz) {
      var el = ui.querySelector('.pbnvp-hcfrom');
      if (!el) {
        var lq0 = ui.querySelector('.pbnvp-lq'); if (!lq0) return;
        el = document.createElement('div'); el.className = 'pbnvp-hcfrom'; el.hidden = true;
        lq0.parentNode.insertBefore(el, lq0.nextSibling);
      }
      var ori = orientOf(cz), txt = '';
      if (!onHC && (pending || !exists(cs, cz, HC))) {
        if (ori === 'Square') {
          if (maxWide(cs)) txt = 'Max color kits come in tall and wide sizes only.';
          else { var lp = maxFrom(cs, 'Portrait'); if (lp) txt = 'Max color kits are portrait only, from ' + lp + '.'; }
        } else { var lo = maxFrom(cs, ori); if (lo) txt = 'Max color kits start at ' + lo + '.'; }
      }
      el.textContent = txt; el.hidden = !txt;
    }
    var hasShapes = !!ui.querySelector('.pbnvp-shapes');
    /* sort size rows smallest -> biggest by cm area */
    var panel = ui.querySelector('.pbnvp-ddpanel');
    if (panel) {
      var rowsAll = [].slice.call(panel.querySelectorAll('.pbnvp-ddrow'));
      rowsAll.sort(function(a,b){
        function area(r){ var da=+r.getAttribute('data-area'); if(da) return da; var d=parseCm(r.getAttribute('data-size')); return d?d.w*d.h:0; }
        function wid(r){ var d=parseCm(r.getAttribute('data-size')); return d?d.w:0; }
        return (area(a)-area(b)) || (wid(a)-wid(b));
      });
      rowsAll.forEach(function(r){ panel.appendChild(r); });
    }

    /* ---- "Pick a size" ---------------------------------------------------
       Ported from assets/paintly-variant-picker.js so diamond painting behaves
       exactly like paint by numbers. Shopify always has a variant selected, so
       a product page cannot truly load with nothing chosen. Instead the picker
       loads PENDING: the native selects still hold the default variant, so
       price, media and the buy form stay valid, but the size button reads
       "Pick a size", no size row is marked chosen, the price is prefixed
       "From", and add to cart is held until the customer picks. The moment a
       size is settled the state clears and everything behaves as before.

       Skipped when the URL already names a variant, so shared links, ad links
       and back-button restores still land on a real selection.

       clearPending() must run from every branch that settles a size, or the
       size helper (snippets/paintly-size-helper.liquid), which confirms by
       clicking our own .pbnvp-ddrow, leaves the placeholder stuck on the
       collapsed button. */
    var sizeRowCount = ui.querySelectorAll('.pbnvp-ddrow').length;
    var pending = sizeRowCount > 1 && !/[?&]variant=/.test(window.location.search);
    var pscope = vs.closest('.shopify-section') || document;
    var HOLD_TXT = 'Pick a size first';
    function priceBoxes() {
      return [].slice.call(pscope.querySelectorAll('.price .price__regular, .price .price__sale')).filter(function (box) {
        return !box.closest('.pbnvp');
      });
    }
    /* The price block is re-rendered on every variant change, which throws the
       chips away, so they are put back by need rather than held in a list. */
    function addChips() {
      priceBoxes().forEach(function (box) {
        if (box.querySelector('.pbnvp-from')) return;
        var chip = document.createElement('span');
        chip.className = 'pbnvp-from';
        chip.textContent = 'From';
        box.insertBefore(chip, box.firstChild);
      });
    }
    function dropChips() {
      [].slice.call(pscope.querySelectorAll('.pbnvp-from')).forEach(function (c) {
        if (c.parentNode) c.parentNode.removeChild(c);
      });
    }
    function buyButtons() { return [].slice.call(pscope.querySelectorAll('.product-form__submit')); }
    function labelOf(b) { return b.querySelector('.main-atc__label__text') || b.querySelector('.button__label'); }
    var pendApplied = false;
    function applyPending() {
      if (pending) {
        pendApplied = true;
        ui.classList.add('pbnvp-pending');
        if (dd) dd.classList.add('empty');
        addChips();
        buyButtons().forEach(function (b) {
          var lab = labelOf(b);
          /* Re-capture the theme's own label every time it differs from ours,
             not just the first time. After a re-render the stored copy is stale,
             and restoring a stale copy would put "Add to cart" back on a button
             the theme had since rewritten. */
          if (lab && lab.textContent.trim() !== HOLD_TXT) {
            lab.setAttribute('data-pbn-html', lab.innerHTML);
            b.setAttribute('data-pbn-wasdis', b.disabled ? '1' : '0');
          }
          if (lab) lab.textContent = HOLD_TXT;
          var pr = b.querySelector('.main-atc-price'); if (pr) pr.classList.add('hidden');
          b.disabled = true;
          b.setAttribute('aria-disabled', 'true');
          b.classList.add('pbnvp-hold');
        });
      } else if (pendApplied) {
        pendApplied = false;
        if (pendObs) { pendObs.disconnect(); pendObs = null; }
        ui.classList.remove('pbnvp-pending');
        if (dd) dd.classList.remove('empty');
        dropChips();
        buyButtons().forEach(function (b) {
          var lab = labelOf(b);
          if (lab && lab.hasAttribute('data-pbn-html')) {
            lab.innerHTML = lab.getAttribute('data-pbn-html');
            lab.removeAttribute('data-pbn-html');
          }
          var pr = b.querySelector('.main-atc-price'); if (pr) pr.classList.remove('hidden');
          var was = b.getAttribute('data-pbn-wasdis') === '1';
          b.removeAttribute('data-pbn-wasdis');
          b.disabled = was;
          if (was) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
          b.classList.remove('pbnvp-hold');
        });
      }
    }
    /* The theme repaints the buy button and the price block from the Section
       Rendering API after a variant change, and that fetch lands AFTER our own
       change handler has run, so it wipes the hold. Changing the drill shape or
       the frame while no size is picked would otherwise hand the customer a live
       "Add to cart" for the default smallest size, which is the one thing this
       whole state exists to prevent. Watch the section and put the hold back.
       applyPending() only runs when something is actually wrong, so the observer
       cannot chase its own writes. */
    var pendObs = null;
    function pendingBroken() {
      var bad = false;
      buyButtons().forEach(function (b) {
        var lab = labelOf(b);
        if (!b.disabled || !b.classList.contains('pbnvp-hold')) bad = true;
        if (lab && lab.textContent.trim() !== HOLD_TXT) bad = true;
      });
      priceBoxes().forEach(function (box) { if (!box.querySelector('.pbnvp-from')) bad = true; });
      return bad;
    }
    function watchPending() {
      if (pendObs || !pending || !window.MutationObserver) return;
      var root = (pscope === document) ? document.body : pscope;
      if (!root) return;
      pendObs = new MutationObserver(function () {
        if (!pending) return;
        if (pendingBroken()) applyPending();
      });
      pendObs.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    }
    function clearPending() { if (!pending) return; pending = false; applyPending(); sync(); }

    ui.addEventListener('click', function (e) {
      var why = e.target.closest('[data-mx-open]');
      if (why) { openMx(why); return; }
      if (window.PaintlyOptSwitch && !e.target.closest('.posw-bar') && e.target.closest('[data-ds],[data-dspart],[data-tier],[data-size],[data-shape],[data-frame]')) window.PaintlyOptSwitch.clear(ui);
      if (e.target.closest('.pbnvp-soldout')) return;
      var s = e.target.closest('[data-ds]');
      if (s) {
        var sv = s.getAttribute('data-ds');
        shapeInputs.forEach(function (r) { if (r.value === sv && !r.checked) { r.checked = true; fire(r); } });
        return;
      }
      var part = e.target.closest('[data-dspart]');
      if (part) {
        var cur = partsOf(curShape());
        var val = part.getAttribute('data-dsval');
        var want = part.getAttribute('data-dspart') === 'shape'
          ? joinParts(val, cur.mat)
          : joinParts(cur.shape, val);
        shapeInputs.forEach(function (r) { if (r.value === want && !r.checked) { r.checked = true; fire(r); } });
        return;
      }
      var tc = e.target.closest('[data-tier]');
      if (tc && hasHC && frameSel) {
        var T = tc.getAttribute('data-tier');
        var cs0 = curShape(), cz0 = sizeSel ? sizeSel.value : null;
        var moved = false, snap0 = snapState();
        if (T === 'hc') {
          if (frameSel.value === HC) return;
          lastStdFrame = frameSel.value;
          frameSel.value = HC;
          /* Max only exists from 80x100cm, so a smaller size moves to the nearest one that
             has it. While no size is picked yet that is the smallest, and picking it settles the size. */
          if (sizeSel && (pending || !exists(cs0, cz0, HC))) {
            var hcSizes = sizeValues().filter(function (v) { return exists(cs0, v, HC); });
            if (hcSizes.length) { sizeSel.value = pending ? hcSizes.sort(function (a, b) { return areaOfSize(a) - areaOfSize(b); })[0] : nearestSize(hcSizes, cz0); moved = true; }
          }
        } else {
          if (frameSel.value !== HC) return;
          var f0 = stdFrameFor(cs0, pending ? null : cz0);
          if (!pending && !f0 && sizeSel) {
            /* the bigger sizes are Max only: go to the nearest size the standard kit comes in */
            var stdSizes = sizeValues().filter(function (v) { return !!stdFrameFor(cs0, v); });
            if (stdSizes.length) { sizeSel.value = nearestSize(stdSizes, cz0); moved = true; f0 = stdFrameFor(cs0, sizeSel.value); }
          }
          frameSel.value = f0 || lastStdFrame;
        }
        if (moved) clearPending();
        fire(frameSel);
        maxNote('tier', snap0, tc.closest('.pbnvp-lq') || tc);
        return;
      }
      var row = e.target.closest('[data-size]');
      if (row) {
        var snap1 = snapState();
        /* settles the size: tapped directly, or clicked for them by the size
           helper's confirm button */
        if (sizeSel) sizeSel.value = row.getAttribute('data-size');
        if (hasHC && frameSel && sizeSel) {
          /* a size the current Colors and Frame do not come in: keep Colors if the other frame
             has it, otherwise switch Colors */
          var cs1 = curShape(), cf1 = frameSel.value, V1 = sizeSel.value;
          if (!exists(cs1, V1, cf1)) {
            if (cf1 === HC) {
              var sf = stdFrameFor(cs1, V1); if (sf) frameSel.value = sf;
            } else {
              var sf2 = stdFrameFor(cs1, V1);
              if (sf2) frameSel.value = sf2;
              else if (exists(cs1, V1, HC)) { lastStdFrame = cf1; frameSel.value = HC; }
            }
          }
        }
        clearPending();
        if (sizeSel) fire(sizeSel);
        if (dd) dd.classList.remove('open');
        maxNote('size', snap1, ui.querySelector('.pbnvp-dd') || row);
        return;
      }
      var sh = e.target.closest('[data-shape]');
      if (sh) {
        var S = sh.getAttribute('data-shape');
        var cur = sizeSel ? sizeSel.value : null;
        /* choosing an orientation settles the size too, either by moving it or
           by confirming the one already loaded */
        if (!sizeSel || orientOf(cur) === S) { clearPending(); return; }
        var pick = null, d = parseCm(cur);
        if (d && d.w !== d.h && S !== 'Square') { /* prefer the mirrored size (Tall <-> Wide only) */
          /* Match on the parsed dimensions, not on a string we build here: the
             option value carries an inch suffix now ("50x40cm (20x16in)") and a
             hand-built "50x40cm" would never equal it, dropping us into the
             generic fallback and landing on the smallest matching size. */
          var mr = null;
          ui.querySelectorAll('[data-size]').forEach(function (r) {
            var q = parseCm(r.getAttribute('data-size'));
            if (q && q.w === d.h && q.h === d.w) mr = r;
          });
          if (mr && !mr.classList.contains('pbnvp-soldout')) pick = mr.getAttribute('data-size');
        }
        if (!pick) {
          var match = [].slice.call(ui.querySelectorAll('[data-size]')).filter(function (r) { return orientOf(r.getAttribute('data-size')) === S; });
          var avail = match.filter(function (r) { return !r.classList.contains('pbnvp-soldout'); })
                           .map(function (r) { return r.getAttribute('data-size'); });
          if (avail.length) pick = nearestSize(avail, cur);
        }
        var pickRow = null;
        if (pick) ui.querySelectorAll('[data-size]').forEach(function (r) { if (r.getAttribute('data-size') === pick) pickRow = r; });
        if (pickRow) { viaShape = S; try { pickRow.click(); } finally { viaShape = null; } return; }
        if (pick) { sizeSel.value = pick; clearPending(); fire(sizeSel); }
        else clearPending();
        return;
      }
      var f = e.target.closest('[data-frame]');
      if (f) {
        if (hasHC && frameSel && frameSel.value === HC) return;
        if (frameSel) { frameSel.value = f.getAttribute('data-frame'); lastStdFrame = frameSel.value; fire(frameSel); }
        return;
      }
    });

    function sync() {
      var cs = curShape();
      var cz = sizeSel ? sizeSel.value : null;
      var cf = frameSel ? frameSel.value : null;
      /* while PENDING the size axis gates nothing, because the customer has
         not chosen a size yet */
      var gz = pending ? null : cz;

      ui.querySelectorAll('[data-ds]').forEach(function (b) {
        var V = b.getAttribute('data-ds');
        b.setAttribute('aria-pressed', V === cs);
        b.classList.toggle('pbnvp-soldout', !exists(V, gz, cf));
      });

      /* the two halves: each is chosen if the current combined value holds it, and sold out when
         the combination it would make cannot be bought at this size and frame */
      if (splitMat) {
        var now = partsOf(cs);
        /* the material pictures follow the shape */
        if (now.shape) ui.setAttribute('data-dshape', now.shape);
        ui.querySelectorAll('[data-dspart]').forEach(function (b) {
          var which = b.getAttribute('data-dspart');
          var V = b.getAttribute('data-dsval');
          b.setAttribute('aria-pressed', V === (which === 'shape' ? now.shape : now.mat));
          /* Judged against the other half's current answer, the same way a size row is judged
             against the drills and the frame. Asking instead whether ANY combination holds this
             half leaves a card looking available that leads nowhere: with resin chosen and round
             resin sold out, round would stay lit and tapping it would land the customer on a
             variant nobody can buy. */
          var want = which === 'shape' ? joinParts(V, now.mat) : joinParts(now.shape, V);
          b.classList.toggle('pbnvp-soldout', !exists(want, gz, cf));
        });
      }

      var selRow = null;
      ui.querySelectorAll('[data-size]').forEach(function (r) {
        var V = r.getAttribute('data-size');
        r.setAttribute('aria-pressed', !pending && V === cz);
        if (hasHC) {
          /* reachable if it comes in the current Colors and Frame, or by switching one of them;
             the row click does that switch */
          var hcHere = exists(cs, V, HC), stdHere = !!stdFrameFor(cs, V);
          r.classList.toggle('pbnvp-soldout', !(exists(cs, V, cf) || hcHere || stdHere));
          r.classList.toggle('pbnvp-hconly', hcHere && !stdHere);
        } else {
          r.classList.toggle('pbnvp-soldout', !exists(cs, V, cf));
        }
        if (V === cz) selRow = r;
      });
      var curOri = (cz && !pending) ? orientOf(cz) : null;
      if (hasShapes) {
        ui.querySelectorAll('.pbnvp-shape').forEach(function (b) {
          var S = b.getAttribute('data-shape');
          b.setAttribute('aria-pressed', S === curOri);
          var any = false;
          ui.querySelectorAll('[data-size]').forEach(function (r) { if (orientOf(r.getAttribute('data-size')) === S && !r.classList.contains('pbnvp-soldout')) any = true; });
          b.classList.toggle('pbnvp-soldout', !any);
        });
        ui.querySelectorAll('[data-size]').forEach(function (r) {
          r.classList.toggle('pbnvp-hide', !!curOri && orientOf(r.getAttribute('data-size')) !== curOri);
        });
      }
      var lbl = ddbtn ? ddbtn.querySelector('.pbnvp-ddlabel') : null;
      if (lbl) {
        if (pending) {
          lbl.innerHTML = '<span class="pbnvp-ddsize"><span class="pbnvp-cmv">Pick a size</span> <span class="pbnvp-inv">' + sizeRowCount + ' to choose from</span></span>';
        } else if (selRow) {
          var ori = selRow.getAttribute('data-orient');
          lbl.innerHTML =
            '<span class="pbnvp-badge ' + (ori === 'Square' ? 'sq' : (ori === 'Landscape' ? 'lan' : 'por')) + '">' + (ori === 'Square' ? SQ : (ori === 'Landscape' ? LAN : POR)) + ori + '</span>' +
            '<span class="pbnvp-ddsize"><span class="pbnvp-cmv">' + selRow.getAttribute('data-cm') + '</span> <span class="pbnvp-inv">' + selRow.getAttribute('data-in') + '</span></span>';
        }
      }

      var onHC = hasHC && cf === HC;
      ui.querySelectorAll('[data-frame]').forEach(function (b) {
        var V = b.getAttribute('data-frame');
        b.setAttribute('aria-pressed', V === (onHC ? 'Without Frame' : cf));
        b.classList.toggle('pbnvp-soldout', onHC ? V !== 'Without Frame' : !exists(cs, gz, V));
      });
      if (hasHC) {
        ui.querySelectorAll('[data-tier]').forEach(function (b) {
          var T = b.getAttribute('data-tier');
          b.setAttribute('aria-pressed', T === (onHC ? 'hc' : 'std'));
          var reach = sizeValues().some(function (v) { return T === 'hc' ? exists(cs, v, HC) : !!stdFrameFor(cs, v); });
          b.classList.toggle('pbnvp-soldout', !reach);
        });
        var note = ui.querySelector('.pbnvp-hcnote');
        if (note) note.hidden = !onHC;
        hcFromLine(onHC, cs, cz);
        /* the switch: move the blob when the answer changes, with the goo filter on only for the trip */
        var lq = ui.querySelector('.pbnvp-lq');
        if (lq && lq.classList.contains('is-max') !== onHC) {
          lq.classList.toggle('is-max', onHC);
          if (!reduceMotion) {
            lq.classList.remove('is-moving'); void lq.offsetWidth; lq.classList.add('is-moving');
            clearTimeout(lq._pbnvpMv);
            lq._pbnvpMv = setTimeout(function () { lq.classList.remove('is-moving'); }, 950);
          }
        }
      }
    }

    function syncAll() { sync(); applyPending(); }
    vs.addEventListener('change', syncAll);
    syncAll();
    watchPending();
  }

  function boot() { document.querySelectorAll('variant-selects.pbnvp-host-dp').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
